import React, { Component } from 'react'

class ClassComp extends Component {
  render() {
    return (
      <div>This is a Class Component!</div>
    )
  }
}

export default ClassComp;
